import { render, staticRenderFns } from "./piece-card.vue?vue&type=template&id=4ae0d7be&scoped=true"
import script from "./piece-card.vue?vue&type=script&lang=js"
export * from "./piece-card.vue?vue&type=script&lang=js"
import style0 from "./piece-card.vue?vue&type=style&index=0&id=4ae0d7be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae0d7be",
  null
  
)

export default component.exports